import {
  RoomId,
  roomId,
  StreamId,
  streamId,
  streamIsActive,
  StreamIsActive
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomStageLayoutMainSetCmd {
  private static validation = JsonSchemaValidator.compile(
    RoomStageLayoutMainSetCmd.validationSchema()
  );

  constructor(readonly cmd: RoomStageLayoutMainSet) {
    JsonSchemaValidator.assert(RoomStageLayoutMainSetCmd.validation, cmd);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["roomId", "streamId", "streamIsActive"],
      properties: {
        roomId,
        streamId,
        streamIsActive
      }
    };
  }
}

interface RoomStageLayoutMainSet {
  roomId: RoomId;
  streamId: StreamId;
  streamIsActive: StreamIsActive;
}
